<div class="a-input-search"
	 data-t-name="InputSearch">
	<div class="a-input-search__search-box"
		 [ngClass]="{'a-input-search__search-box--is-focused': isFocused }">
		<input type="text" #searchInput
			   class="a-input-search__input"
			   [(ngModel)]="searchText"
			   (keyup)="onKeyUp($event)"
			   (focus)="isFocused = true"
			   (blur)="isFocused = false"/>
		<div class="a-input-search__search-box--input-wrapper" (mousedown)="searchChanged()">
			<span class="a-input-search__search-box--input-wrapper-icon"></span>
		</div>
		<div class="a-input-search__search-box--clear-icon-wrapper" (mousedown)="onSearchClearIconClick()"
			 *ngIf="searchText && isFocused">
			<span class="a-input-search__search-box--clear-icon-wrapper-clear-icon"></span>
		</div>
	</div>
</div>
